import { GridColDef } from "@mui/x-data-grid";
import SbuxTranslate from "../SbuxTranslate";

/**
 * Wraps all column headers with SbuxTranslate component
 * @param {Array} columns DataGrid column definitions
 * @returns {Array} Columns with translated headers
 */
export const getTranslatedColumns = (columns: GridColDef[]): GridColDef[] =>
  columns.map((col) => ({
    ...col,
    renderHeader: col.headerName
      ? () => <SbuxTranslate>{col.headerName}</SbuxTranslate>
      : col.renderHeader,
  }));
